import styled from 'styled-components';
import { Button, Modal, Accordion, TabPane } from 'semantic-ui-react'

export const CardWrapper = styled.div`
padding-bottom: 5px !important;
border-radius: 10px !important;
background-color: rgb(247, 247, 247);
padding: 12px;
position: relative;
margin-bottom: 10px;
margin-top: 10px;
`
export const TabPaneStyled = styled(TabPane)`
padding: 0 !important;
background: none !important;
border: none !important;
padding-bottom: 1rem !important;
`

export const StyledDeleteButton = styled(Button)`
position: absolute;
top: 5px;
right: ${props => props.rightAlign ? `${props.rightAlign}px` : '0'};
`
export const TabPaneLangugeStyled = styled(TabPane)`
border: none !important;
`
export const StyledPreviewModal = styled(Modal)`
height: 90vh !important;
 .content {
  height: 100% !important;
 }
`
export const StyledAccordionTitle = styled.div`
font-size: 16px !important;
`
export const StyledAccordion = styled(Accordion)`
 .title {
 >i{
  display: none !important;
 }
}
`